/* eslint-disable react-hooks/exhaustive-deps */

import { Box, Button, Grid, Link, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { signOut } from "aws-amplify/auth";

import IconRejected from "@components/Images/IconRejected";
import CustomRightImage from "@components/CustomRightImagev2";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";

interface SinOfertaProps {
  type: "rechazado" | "sin_oferta";
}

const SinOferta: React.FC<SinOfertaProps> = ({ type }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const personal_data = useSelector((state: RootState) => state.register.personal_data);

  const [name, setName] = useState("");

  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const handleClick = async () => {
    await signOut();
    navigate("/login");
  };

  useEffect(() => {
    const fullName = `${personal_data.name} ${personal_data.first_lastname} ${personal_data.second_lastname}`.trim();
    setName(fullName);
    document.body.style.backgroundColor =
      theme?.palette?.screens?.bofu?.backgroundColor || theme?.palette?.primary?.base;
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  return (
    <Grid
      container
      height="100%"
      sx={{
        color: theme?.palette?.screens?.bofu?.titleColor || theme?.palette?.primary?.dark,
      }}
    >
      <Grid item xs={12} md={8} mt={5}>
        <Box textAlign="center">
          <Typography
            variant={isMobileOrTablet ? "h4" : "h3"}
            color={theme?.palette?.screens?.bofu?.titleColor || theme?.palette?.primary?.main}
            fontWeight="bold"
          >
            ¡Hola!
          </Typography>

          <Typography variant={isMobileOrTablet ? "h4" : "h3"} fontWeight="bold" mt={2}>
            {name || "Nombre del cliente"}
          </Typography>

          {type === "sin_oferta" && (
            <Box mt={4}>
              <Typography variant={isMobileOrTablet ? "body2" : "body1"}>
                Tu solicitud sigue activa en nuestro Marketplace. Aún no ha sido seleccionada por ninguna de las
                instituciones financieras aliadas.
              </Typography>

              <Typography variant={isMobileOrTablet ? "body2" : "body1"} mt={1}>
                Recuerda que las financieras revisan solicitudes de forma continua, así que aún puede haber
                oportunidades.
              </Typography>

              <Typography
                variant={isMobileOrTablet ? "body2" : "body1"}
                color={theme?.palette?.screens?.bofu?.subtitleColor || theme?.palette?.primary?.main}
                mt={4}
                fontWeight="bold"
              >
                ¡No te desanimes!
              </Typography>
            </Box>
          )}

          {type === "rechazado" && (
            <Box mt={4}>
              <Typography variant={isMobileOrTablet ? "body2" : "body1"}>
                En esta ocasión, tu solicitud no recibió propuestas dentro del tiempo establecido.
              </Typography>

              <Typography variant={isMobileOrTablet ? "body2" : "body1"} mt={1}>
                Sabemos que puede ser frustrante, pero tu camino al financiamiento no termina aquí.
              </Typography>

              <Typography
                variant={isMobileOrTablet ? "body2" : "body1"}
                color={theme?.palette?.screens?.bofu?.subtitleColor || theme?.palette?.primary?.main}
                mt={4}
                fontWeight="bold"
              >
                Vuelve a intentarlo en 3 meses con tu información actualizada.
                <br />
                Estaremos aquí para ayudarte a lograrlo.
              </Typography>
            </Box>
          )}

          <Box display="flex" justifyContent="center" mt={4} mb={4}>
            <IconRejected
              width={isMobileOrTablet ? "110" : "170"}
              fill={theme?.palette?.screens?.bofu?.iconColor || theme.palette.primary.dark}
            />
          </Box>

          <Box display="flex" justifyContent="center" mt={4}>
            <Button variant="default" onClick={handleClick} sx={{ width: "130px" }}>
              Salir
            </Button>
          </Box>

          {type === "sin_oferta" && (
            <Typography variant={isMobileOrTablet ? "body2" : "body1"} mt={4}>
              Para cualquier duda o aclaración contáctanos a: <br />
              Tel: <Link href="tel:+525591044964">55 9104 4964</Link> <br />
              Correo: <Link href="mailto:contacto@lendia.mx">contacto@lendia.mx</Link>
            </Typography>
          )}
        </Box>
      </Grid>

      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default SinOferta;
